import Box from '@amzn/meridian/box';
import React, { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router';
import Page from '../../Types/Page';
import Row from '@amzn/meridian/row';
import CreateGoal from '../Goals/CreateGoal';
import { GoalLevel } from '@amzn/aet-galactus-kit';
import { StateContext } from '../../GlobalStateStore';
import { Profile } from '../../Types';
import { Feature, isFeatureEnabled } from '../../config/FeaturesConfig';
import CoachingHistoryTm from './CoachingHistoryTm';
import ConsolidatedContacts from './ConsolidatedContacts/ConsolidatedContacts';
import DataState from '../../Types/DataState';
import GoalSettingContainerWrapper from '../Goals/GoalSettingContainer';
import { GoalPage } from '../Goals/helper';

type CoachingHomeTmProps = {
  coachProfile: Profile;
  coachProfileState: string;
  coacheeProfile: Profile;
  coacheeProfileState: string;
};

const CoachingHomeTm: React.FC<CoachingHomeTmProps> = ({
  coachProfile,
  coachProfileState,
  coacheeProfile,
  coacheeProfileState,
}): React.ReactElement => {
  const { userId } = useParams() as { userId: string };
  const globalState = useContext(StateContext);
  const { inspireOptions } = globalState.state;
  const contactRecommenderEnabled = isFeatureEnabled(
    Feature.CONTACT_RECOMMENDER
  );
  const goalSettingEnabled = isFeatureEnabled(Feature.GOAL_SETTING);

  const [refreshGoalsFlag, setRefreshGoalsFlag] = useState(false);
  const handleAddGoal = () => {
    setRefreshGoalsFlag(!refreshGoalsFlag);
  };
  const [isCreateGoalOpen, setIsCreateGoalOpen] = useState(false);
  let scrollingEnabled = true;

  useEffect(() => {
    const hash = window.location.hash;
    if (hash && hash.startsWith('#')) {
      const newHash = hash.replace(/[?&]ie=UTF8(&|$)/, (match, p1) =>
        p1 === '&' ? '?' : ''
      );
      const scrollToElement = () => {
        const element = document.querySelector(newHash);
        if (element && scrollingEnabled) {
          if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
          }
          setTimeout(() => {
            scrollingEnabled = false;
          }, 2000);
        }
      };

      scrollToElement();

      const observer = new MutationObserver(() => {
        scrollToElement();
      });

      observer.observe(document.body, { childList: true, subtree: true });

      return () => {
        observer.disconnect();
      };
    }
  }, []);

  return (
    <Row
      width='100%'
      widths={['fill', 'fit']}
      alignmentVertical='top'
      height='100%'
    >
      <Box>
        <CoachingHistoryTm userId={userId} week={null} />
        {goalSettingEnabled && (
          <GoalSettingContainerWrapper
            loading={
              coacheeProfileState === DataState.LOADING ||
              coachProfileState === DataState.LOADING
            }
            loaded={
              coacheeProfileState === DataState.LOADED &&
              coachProfileState === DataState.LOADED
            }
            error={
              coacheeProfileState === DataState.ERROR ||
              coachProfileState === DataState.ERROR
            }
            displayedProfile={coacheeProfile}
            loggedInProfile={coachProfile}
            refreshGoalsFlag={refreshGoalsFlag}
            setIsCreateGoalOpen={setIsCreateGoalOpen}
            page={GoalPage.COACHING}
          />
        )}
        {contactRecommenderEnabled && (
          <ConsolidatedContacts
            userId={userId}
            week={null}
            sourcePage={Page.TEAM}
          />
        )}
      </Box>
      {goalSettingEnabled && (
        <CreateGoal
          isOpen={isCreateGoalOpen}
          setIsOpen={setIsCreateGoalOpen}
          lockedGoalLevel={true}
          defaultAssociateID={userId}
          cscEntityPrefix={inspireOptions.data.cscEntityPrefix}
          profile={coachProfile}
          changeFlag={handleAddGoal}
          page={GoalPage.COACHING}
        />
      )}
    </Row>
  );
};

export default CoachingHomeTm;
